module.exports = __webpack_public_path__ + "assets/icon-trending-up-component.f8368380.svg";